<template>
  <div :class="bem.b()">
    <ll-segmented v-model:value="type" :options="batchEditingOptions">
      <template #label="{ payload }">
        <div>{{ payload.title }}</div>
      </template>
    </ll-segmented>
    <div :class="bem.e('textarea')">
      <ll-textarea
        v-model:value="innerValue"
        :disabled="disabled"
        :placeholder="currentPlaceholder"
        :autosize="{ minRows: 10 }"
        :bordered="false"
      />
      <p v-if="type === 'comma'" :class="bem.e('textarea-tip')">
        数据格式遵循
        <a href="javascript:;">《标准 CSV 规范》</a>
        字段之间以英文逗号( , )分隔，多条记录以换行分隔
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, inject } from 'vue'

import {
  batchEditingOptions,
  batchEditingProps,
  batchEditingEmits
} from '../config'

import { createNamespace } from '@ll-plus/utils'

defineOptions({ name: 'LlBatchEditing' })

const props = defineProps(batchEditingProps)

const emits = defineEmits(batchEditingEmits)

const bem = createNamespace('batch-editing')

const type = ref('comma')

const disabled = inject('disabled')

const currentPlaceholder = computed(() => {
  return type.value === 'comma'
    ? '格式: 启用,参数名,参数值,类型,必需备份'
    : '格式：参数名：参数值'
})

const innerValue = ref(props.value)

//TODO:切换类型时准换数据格式

watch(innerValue, () => {
  emits('update:value', innerValue.value)
})
</script>
